// FNP-211: source the canonical query string from the shared library.
import { listApplicationProducts } from '@flexinet/pricing-components';
import { listApplications } from '../../../accounts-management/applications/services/queries';
import { GraphQLQuery } from '@aws-amplify/api';
import { ListApplicationProducts } from '../types';
import { ListApplications } from '../../../accounts-management/applications/services/ApplicationsService';
import { notifyError } from '../../../../components/ServiceNotifications';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const fetchApplications = async () => {
    try {
        const response = await client.graphql<GraphQLQuery<ListApplications>>({
            query: listApplications,
        });
        return response.data?.listApplications.items ?? [];
    } catch (e) {
        notifyError(e);
        return [];
    }
};

export const fetchApplicationProducts = async (applicationId?: string) => {
    try {
        const filter = applicationId ? { applicationId } : undefined;
        const response = await client.graphql<GraphQLQuery<ListApplicationProducts>>({
            query: listApplicationProducts,
            variables: { filter },
        });
        return response.data?.listApplicationProducts.items ?? [];
    } catch (e) {
        notifyError(e);
        return [];
    }
};
